webpackJsonp([1],{

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var GoogleMap = /** @class */ (function (_super) {
    __extends(GoogleMap, _super);
    function GoogleMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleMap.prototype.createMap = function (location) {
        var element = this.$el;
        var zoom = parseFloat(this.zoom) || 12;
        var minZoom = parseFloat(this.minZoom) || zoom;
        var maxZoom = parseFloat(this.maxZoom) || zoom;
        var latLng = location || {
            lat: parseFloat(this.latitude),
            lng: parseFloat(this.longitude)
        };
        var enableControls = !!this.shouldShowControls;
        var options = {
            gestureHandling: 'cooperative',
            zoom: zoom,
            minZoom: minZoom,
            maxZoom: maxZoom,
            center: latLng,
            styles: this._data.styles,
            disableDefaultUI: !enableControls,
            keyboardShortcuts: enableControls,
            panControl: enableControls,
            draggable: enableControls,
            zoomControl: enableControls,
            mapTypeControl: false,
            scaleControl: enableControls,
            streetViewControl: false,
            overviewMapControl: enableControls,
            rotateControl: enableControls,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP]
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        var map = new google.maps.Map(element, options);
        if (this.markerJson) {
            var markers = JSON.parse(this.markerJson);
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                var latLng_1 = {
                    lat: marker.lat,
                    lng: marker.lng
                };
                new google.maps.Marker({
                    position: latLng_1,
                    map: map,
                    icon: marker.icon
                });
            }
        }
        this._data.map = map;
    };
    GoogleMap.prototype.fetchAddress = function (address, callback) {
        new google.maps.Geocoder().geocode({ address: address }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                return null;
            }
            if (callback) {
                callback(results);
            }
            return results;
        });
    };
    GoogleMap.prototype.mounted = function () {
        var _this = this;
        var lat = parseFloat(this.latitude);
        var lng = parseFloat(this.longitude);
        if (!(lat || lng) && this.address) {
            this.fetchAddress(this.address, function (locations) {
                _this._data.location = locations[0].geometry.location;
                _this.createMap(_this._data.location);
            });
        }
        else if (lat || lng) {
            this._data.location = {
                lat: lat,
                lng: lng
            };
            this.createMap(this._data.location);
        }
        window.addEventListener('resize', this.handleResize);
    };
    GoogleMap.prototype.beforeDestroy = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    GoogleMap.prototype.handleResize = function () {
        this._data.map.setCenter(this._data.location);
    };
    GoogleMap.prototype.data = function () {
        return {
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#9d9d9d"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#9d9d9d"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                }
            ]
        };
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "id", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "address", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "latitude", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "longitude", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "minZoom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "maxZoom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "zoom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "markerJson", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], GoogleMap.prototype, "shouldShowControls", void 0);
    GoogleMap = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], GoogleMap);
    return GoogleMap;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (GoogleMap);


/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var NewsSlider = /** @class */ (function (_super) {
    __extends(NewsSlider, _super);
    function NewsSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewsSlider.prototype.data = function () {
        this._articlesPerSlide = this.model.slideSize;
        this._totalCount = this.model.totalCount;
        return {
            slides: this.calulateSlides(this.model.news, this.getArticlesPerSlideAmount()),
            currentSlideNo: 1,
            articlesPerSlide: this.getArticlesPerSlideAmount(),
            dataUrl: this.model.dataUrl,
            isDataRequestInProgress: false,
            allNews: this.model.news
        };
    };
    NewsSlider.prototype.mounted = function () {
        window.addEventListener('resize', this.handleResize);
        this.calculateVisibleSlide();
    };
    NewsSlider.prototype.beforeDestroy = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    NewsSlider.prototype.next = function () {
        this.slideForward();
    };
    NewsSlider.prototype.prev = function () {
        this.slideBackwards();
    };
    NewsSlider.prototype.slideForward = function () {
        var _this = this;
        var slidesShown = this._data.currentSlideNo * this._data.articlesPerSlide;
        if (slidesShown >= this._totalCount
            || this._data.isDataRequestInProgress) {
            return;
        }
        this._data.currentSlideNo++;
        this.calculateVisibleSlide();
        if (this._data.slides.length >= this._data.currentSlideNo) {
            return;
        }
        var data = {
            nextSlide: Math.ceil(slidesShown / this._articlesPerSlide)
        };
        this._data.isDataRequestInProgress = true;
        __WEBPACK_IMPORTED_MODULE_1__brightspark_sparkling_ajax_js__(this._data.dataUrl, { dataType: "json", method: "post", data: data })
            .done(function (res) {
            if (!res) {
                return;
            }
            for (var i = 0; i < res.length; i++) {
                _this._data.allNews.push(res[i]);
            }
            _this.updateSlides();
            _this._data.isDataRequestInProgress = false;
        });
    };
    NewsSlider.prototype.slideBackwards = function () {
        if (this._data.currentSlideNo === 1) {
            return;
        }
        this._data.currentSlideNo--;
        this.calculateVisibleSlide();
    };
    NewsSlider.prototype.getArticlesPerSlideAmount = function () {
        var screenSize = {
            mobileSmall: 650,
            mobile: 767,
            tablet: 1023
        };
        var articlesPerSlide = this._articlesPerSlide;
        var currentWindowWidth = window.innerWidth;
        if (currentWindowWidth < screenSize.tablet) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobile) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobileSmall) {
            articlesPerSlide = 1;
        }
        return articlesPerSlide;
    };
    NewsSlider.prototype.handleResize = function (e) {
        var articlesPerSlide = this.getArticlesPerSlideAmount();
        if (this._data.articlesPerSlide === articlesPerSlide) {
            return;
        }
        this._data.articlesPerSlide = articlesPerSlide;
        this.calulateSlides(this._data.allNews, articlesPerSlide);
    };
    NewsSlider.prototype.updateSlides = function () {
        this.calulateSlides(this._data.allNews, this._data.articlesPerSlide, false);
    };
    NewsSlider.prototype.calulateSlides = function (articles, articlesPerSlide, resetCurSlide) {
        if (resetCurSlide === void 0) { resetCurSlide = true; }
        var slides = [];
        var currentSlide = {
            news: [],
            display: false
        };
        for (var i = 0; i < articles.length; i++) {
            if (i % articlesPerSlide === 0) {
                currentSlide = {
                    news: [],
                    display: false
                };
                slides.push(currentSlide);
            }
            currentSlide.news.push(articles[i]);
        }
        if (this._data) {
            if (resetCurSlide) {
                this._data.currentSlideNo = 1;
            }
            this._data.slides = slides;
            this.calculateVisibleSlide();
        }
        return slides;
    };
    NewsSlider.prototype.calculateVisibleSlide = function () {
        for (var i = 0; i < this._data.slides.length; i++) {
            this._data.slides[i].display = this._data.currentSlideNo - 1 === i;
        }
    };
    Object.defineProperty(NewsSlider.prototype, "longestNews", {
        get: function () {
            var longestArticle = this._data.slides[0].news[0];
            var longestArticleLenght = longestArticle.shortDescription.length + longestArticle.title.length;
            for (var i = 1; i < this._data.slides.length; i++) {
                var slide = this._data.slides[i];
                for (var j = 1; j < slide.news.length; j++) {
                    var news = slide.news[j];
                    var isLonger = news.shortDescription.length + news.title.length
                        > longestArticleLenght;
                    if (isLonger) {
                        longestArticle = news;
                    }
                }
            }
            return longestArticle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsSlider.prototype, "nextButtonClass", {
        get: function () {
            var classList = ["landing__news__control", "landing__news--next"];
            if (this._data.currentSlideNo * this._data.articlesPerSlide >= this._totalCount) {
                classList.push("landing__news--disabled");
            }
            return classList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsSlider.prototype, "prevButtonClass", {
        get: function () {
            var classList = ["landing__news__control", "landing__news--prev"];
            if (this._data.currentSlideNo < 2) {
                classList.push("landing__news--disabled");
            }
            return classList;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], NewsSlider.prototype, "model", void 0);
    NewsSlider = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], NewsSlider);
    return NewsSlider;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (NewsSlider);


/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var MessageSlider = /** @class */ (function (_super) {
    __extends(MessageSlider, _super);
    function MessageSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.SLIDER_INTERVAL = 3000;
        _this._timeout = null;
        return _this;
    }
    MessageSlider.prototype.data = function () {
        for (var i = 0; i < this.model.articles.length; i++) {
            // initializing display property, so vue would recognize it
            this.model.articles[i].display = false;
        }
        return {
            articles: this.model.articles,
            currentSlideNo: 1,
            slideElAmount: this.model.slideSize,
            slidesAmount: Math.ceil(this.model.totalCount / this.model.slideSize),
            dataUrl: this.model.dataUrl
        };
    };
    MessageSlider.prototype.mounted = function () {
        this.calculateVisibleElements();
        this.turnOnTimeout();
    };
    MessageSlider.prototype.resetTimeout = function () {
        this.turnOffTimeout();
        this.turnOnTimeout();
    };
    MessageSlider.prototype.turnOnTimeout = function () {
        var component = this;
        this._timeout = setTimeout(function () {
            component.slideForward();
            component.turnOnTimeout();
        }, this.SLIDER_INTERVAL);
    };
    MessageSlider.prototype.turnOffTimeout = function () {
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
    };
    MessageSlider.prototype.next = function () {
        this.turnOffTimeout();
        this.slideForward();
        this.turnOnTimeout();
    };
    MessageSlider.prototype.prev = function () {
        this.turnOffTimeout();
        this.slideBackwards();
        this.turnOnTimeout();
    };
    MessageSlider.prototype.slideBackwards = function () {
        if (this._data.isDataRequestInProgress) {
            return;
        }
        if (--this._data.currentSlideNo <= 0) {
            this._data.currentSlideNo = this._data.slidesAmount;
        }
        this.calculateVisibleElements();
    };
    MessageSlider.prototype.slideForward = function () {
        if (this._data.isDataRequestInProgress) {
            return;
        }
        if (this._data.currentSlideNo++ >= this._data.slidesAmount) {
            this._data.currentSlideNo = 1;
        }
        this.calculateVisibleElements();
    };
    MessageSlider.prototype.calculateVisibleElements = function () {
        var start = (this._data.currentSlideNo - 1) * this._data.slideElAmount;
        var end = start + this._data.slideElAmount;
        for (var i = 0; i < this._data.articles.length; i++) {
            this._data.articles[i].display = start <= i && end > i;
        }
    };
    Object.defineProperty(MessageSlider.prototype, "longestMessage", {
        get: function () {
            var longestArticle = this._data.articles[0];
            for (var i = 1; i < this._data.articles.length; i++) {
                if (longestArticle.title.length < this._data.articles[i].title.length) {
                    longestArticle = this._data.articles[i];
                }
            }
            return longestArticle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageSlider.prototype, "nextButtonClass", {
        get: function () {
            var classList = ["button button--secondary"];
            return classList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageSlider.prototype, "prevButtonClass", {
        get: function () {
            var classList = ["button button--secondary-reverse"];
            return classList;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], MessageSlider.prototype, "model", void 0);
    MessageSlider = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], MessageSlider);
    return MessageSlider;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (MessageSlider);


/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_ContactView__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_FaqView__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home_IndexView__ = __webpack_require__(516);




__WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__["a" /* ViewFactory */].setRegistry({
    'ContactView': __WEBPACK_IMPORTED_MODULE_1__Home_ContactView__["a" /* ContactView */],
    'FaqView': __WEBPACK_IMPORTED_MODULE_2__Home_FaqView__["a" /* FaqView */],
    'IndexView': __WEBPACK_IMPORTED_MODULE_3__Home_IndexView__["a" /* IndexView */]
});


/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_GoogleMap_GoogleMap_vue__ = __webpack_require__(512);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
    }
    return ViewDataModel;
}());
var ContactView = /** @class */ (function (_super) {
    __extends(ContactView, _super);
    function ContactView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    ContactView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".app",
            data: {},
            components: {
                GoogleMap: __WEBPACK_IMPORTED_MODULE_2__Components_GoogleMap_GoogleMap_vue__["a" /* default */]
            }
        });
    };
    return ContactView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_GoogleMap_ts__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73732094_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__(513);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_GoogleMap_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73732094_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\GoogleMap\\GoogleMap.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73732094", Component.options)
  } else {
    hotAPI.reload("data-v-73732094", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "google-map", attrs: { id: _vm.id } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73732094", esExports)
  }
}

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FaqView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_CollapsibleBlock_CollapsibleBlock_vue__ = __webpack_require__(268);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var FaqView = /** @class */ (function (_super) {
    __extends(FaqView, _super);
    function FaqView() {
        var _this = _super.call(this) || this;
        _this.SetupVue();
        return _this;
    }
    FaqView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".app",
            data: {},
            components: {
                CollapsibleBlock: __WEBPACK_IMPORTED_MODULE_2__Components_CollapsibleBlock_CollapsibleBlock_vue__["a" /* default */]
            }
        });
    };
    return FaqView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndexView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_NewsSlider_NewsSlider_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_MessageSlider_MessageSlider_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Xelect_XelectComponent_vue__ = __webpack_require__(75);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var Action;
(function (Action) {
    Action[Action["UpdateFilters"] = 0] = "UpdateFilters";
})(Action || (Action = {}));
var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
        this.showGroupLevelsWith = [];
        this.groupType = "";
        this.groupLevel = "";
        this.trainer = "";
        this.location = "";
    }
    return ViewDataModel;
}());
var IndexView = /** @class */ (function (_super) {
    __extends(IndexView, _super);
    function IndexView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    IndexView.prototype.SetupVue = function () {
        var components = [];
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".app",
            data: {
                showGroupLevelsWith: this._viewData.showGroupLevelsWith,
                groupLevels: new Array(),
                groupTypes: new Array(),
                trainers: new Array(),
                locations: new Array(),
                groupType: this._viewData.groupType,
                groupLevel: this._viewData.groupLevel,
                trainer: this._viewData.trainer,
                location: this._viewData.location
            },
            mounted: function () {
                this.change();
            },
            components: {
                //TimetableFilters,
                NewsSlider: __WEBPACK_IMPORTED_MODULE_5__Components_NewsSlider_NewsSlider_vue__["a" /* default */],
                MessageSlider: __WEBPACK_IMPORTED_MODULE_6__Components_MessageSlider_MessageSlider_vue__["a" /* default */],
                Carousel: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Carousel"],
                Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Slide"],
                XelectComponent: __WEBPACK_IMPORTED_MODULE_7__Components_Xelect_XelectComponent_vue__["a" /* default */]
            },
            computed: {
                shouldShowGroupLevels: function () {
                    var vue = this;
                    var index = vue.showGroupLevelsWith.indexOf(vue.groupType.toLowerCase());
                    return index > -1;
                }
            },
            methods: {
                valueChanged: function (value, component) {
                    var name = component.name;
                    var vue = this;
                    if (vue[name] === value) {
                        return;
                    }
                    switch (name) {
                        case "LocationId":
                            vue.location = value;
                            break;
                        case "TrainerId":
                            vue.trainer = value;
                            break;
                        case "GroupTypeId":
                            vue.groupType = value;
                            break;
                        case "GroupLevel":
                            vue.groupLevel = value;
                            break;
                        default:
                            return;
                    }
                    vue.change();
                },
                change: function () {
                    var _this = this;
                    var vue = this;
                    var data = {
                        groupLevel: vue.groupLevel,
                        groupTypeId: vue.groupType,
                        trainerId: vue.trainer,
                        locationId: vue.location
                    };
                    __WEBPACK_IMPORTED_MODULE_4__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_3__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.UpdateFilters]), { dataType: "json", method: "post", data: data })
                        .done(function (res) {
                        if (!res) {
                            return;
                        }
                        _this.locations = res.locations;
                        _this.groupLevels = res.groupLevels;
                        _this.groupTypes = res.groupTypes;
                        _this.trainers = res.trainers;
                    });
                }
            }
        });
    };
    return IndexView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_NewsSlider_ts__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d92006_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsSlider_vue__ = __webpack_require__(518);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_NewsSlider_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d92006_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\NewsSlider\\NewsSlider.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00d92006", Component.options)
  } else {
    hotAPI.reload("data-v-00d92006", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "landing__news" }, [
    _c("div", { class: _vm.prevButtonClass, on: { click: _vm.prev } }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "news__section" },
      [
        _c(
          "transition-group",
          { attrs: { name: "slide-fade", tag: "div" } },
          _vm._l(_vm.slides, function(slide, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: slide.display,
                    expression: "slide.display"
                  }
                ],
                key: index,
                staticClass: "news__slide"
              },
              _vm._l(slide.news, function(item) {
                return _c("div", { staticClass: "news" }, [
                  _c("h2", [_vm._v(_vm._s(item.publishDate))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h5", { staticClass: "news__header" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.title) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(item.shortDescription) }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      { staticClass: "link", attrs: { href: item.link } },
                      [_vm._v("loe edasi")]
                    )
                  ])
                ])
              })
            )
          })
        ),
        _vm._v(" "),
        _c("div", { staticClass: "news__slide news__slide--invisible" }, [
          _c("div", { staticClass: "news" }, [
            _c("h2", [_vm._v(_vm._s(_vm.longestNews.publishDate))]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", { staticClass: "news__header" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.longestNews.title) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.longestNews.shortDescription) }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c(
                "a",
                { staticClass: "link", attrs: { href: _vm.longestNews.link } },
                [_vm._v("loe edasi")]
              )
            ])
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.nextButtonClass, on: { click: _vm.next } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00d92006", esExports)
  }
}

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_MessageSlider_ts__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a75501e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageSlider_vue__ = __webpack_require__(520);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_MessageSlider_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a75501e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\MessageSlider\\MessageSlider.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0a75501e", Component.options)
  } else {
    hotAPI.reload("data-v-0a75501e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing__notification" },
    [
      _c("div", { staticClass: "notification__header" }, [
        _c("h1", [_vm._v("Teated")]),
        _vm._v(" "),
        _c("div", { staticClass: "notification__controls" }, [
          _c("button", { class: _vm.prevButtonClass, on: { click: _vm.prev } }),
          _vm._v(" "),
          _c("button", { class: _vm.nextButtonClass, on: { click: _vm.next } })
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.articles, function(item) {
        return _c(
          "div",
          {
            staticClass: "notification__list",
            on: { mouseover: _vm.turnOffTimeout, mouseleave: _vm.turnOnTimeout }
          },
          [
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.display,
                      expression: "item.display"
                    }
                  ],
                  staticClass: "notification__list-item"
                },
                [
                  _c("div", [
                    _c("div", [
                      _c("img", {
                        staticClass: "notification__img",
                        attrs: { src: item.iconLink }
                      })
                    ]),
                    _vm._v(" "),
                    _c("h2", [_vm._v(_vm._s(item.title))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "landing__training__form__submit" },
                    [
                      _c(
                        "a",
                        { staticClass: "link", attrs: { href: item.link } },
                        [_vm._v("VAATA LÄHEMALT")]
                      )
                    ]
                  )
                ]
              )
            ])
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "notification__list-item notification__list-item--hidden"
        },
        [
          _c("div", [
            _c("div", [
              _c("img", {
                staticClass: "notification__img",
                attrs: { src: _vm.longestMessage.iconLink }
              })
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.longestMessage.title))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "landing__training__form__submit" }, [
            _c(
              "a",
              { staticClass: "link", attrs: { href: _vm.longestMessage.link } },
              [_vm._v("VAATA LÄHEMALT")]
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a75501e", esExports)
  }
}

/***/ })

},[510]);


// WEBPACK FOOTER //
// js/page/home.bundle.js